<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('sevenzip-to-iso-converter', '7z to ISO');

function handleBatchCreated(batchId: string) {
  console.log('[7z to ISO Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[7z to ISO Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[7z to ISO Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[7z to ISO Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[7z to ISO Converter] Credits updated:', credits);
}
</script>
